import { useRequest } from "../../../app/hooks/useRequest";
import {
  getWaitlistsRequest,
  removeWaitlistRequest,
} from "../WaitlistRequests";

export const useGetWaitlists = () => useRequest(getWaitlistsRequest);
export const useRemoveWaitlist = () => useRequest(removeWaitlistRequest);
